import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { store } from './app/store';
import App from './App';
import './index.css';
import './i18n/config';

/**
 * Main React Entry Point
 *
 * - Renders app into #root element
 * - Wraps app with Redux Provider
 * - Strict mode for development warnings
 */

ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
        <Provider store={store}>
            <App />
        </Provider>
    </React.StrictMode>
);